import styled from "@emotion/styled";

export const SignInLink = styled.a((props) => ({
    "&:hover": {
        cursor: "pointer",
    },
}));
